import { useContext } from 'react';
import { Typography, Unstable_Grid2 as Grid } from '@mui/material';

import { LinearProgress, Card, CardContent, CardHeader } from '@occc/ui-design-system';

import LocationScanDataFormContent from '../../components/LocationScanDataFormContent';
import { LocationContext } from '../LocationProvider';

export const LocationScanDataEdit = () => {
  const { loading, location } = useContext(LocationContext);
  const isRjrEligible = !!location?.rjrRbdsCode?.trim();
  return (
    <Card>
      {loading && <LinearProgress />}
      <CardHeader
        title={
          <Typography component='span' variant='h6'>
            Scan Data
          </Typography>
        }
      />
      <CardContent>
        <Grid container columnSpacing={3} rowSpacing={2}>
          <Grid md={12}>
            <LocationScanDataFormContent isRjrEligible={isRjrEligible} />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
